import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisV,
  faTable,
  faCaretUp,
  faCaretDown,
  faChartBar,
  faStar,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import md5 from "md5";
import { Link } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import FilterContext from "../../../routes/FilterContext";
import Table from "react-bootstrap/Table";
class TopActiveTenantsOccupier extends React.Component {
  static contextType = FilterContext;

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="widget widgetTable">
        <div className="row">
          <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
            <p>Top 10 Active Occupiers</p>
          </div>
          <div className="col-lg-12 mt-2">
            <Table responsive hover>
              <thead>
                <tr className="">
                  <th>Developer</th>
                  <th>Built Stock(#)</th>
                  <th>Built Stock(msf)</th>
                  <th className="text-end">Occupancy(%)</th>
                </tr>
              </thead>
              <tbody>
                <tr className="">
                  <td>Accenture</td>
                  <td>IT/ITeS</td>
                  <td>1.1 msf(7%)</td>
                  <td>INR 92 Cr. (10%)</td>
                </tr>
                <tr className="">
                  <td>Accenture</td>
                  <td>IT/ITeS</td>
                  <td>1.1 msf(7%)</td>
                  <td>INR 92 Cr. (10%)</td>
                </tr>
                <tr className="">
                  <td>Accenture</td>
                  <td>IT/ITeS</td>
                  <td>1.1 msf(7%)</td>
                  <td>INR 92 Cr. (10%)</td>
                </tr>
                <tr className="">
                  <td>Accenture</td>
                  <td>IT/ITeS</td>
                  <td>1.1 msf(7%)</td>
                  <td>INR 92 Cr. (10%)</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

export default TopActiveTenantsOccupier;
